import Layout from 'src/components/Layout';
import LoadingPanel from 'src/components/LoadingPanel';
import useCheckbookConfiguration from 'src/hooks/useCheckbookConfiguration';
import CheckbookConfigurationTable from 'src/sections/checkbook_configuration/CheckbookConfigurationTable';
import CheckbookConfigurationNavBar from './CheckbookConfigurationNavBar';

const CheckbookConfiguration = () => {
  const { glMasksInitialLoading } = useCheckbookConfiguration();
  return glMasksInitialLoading ? (
    <LoadingPanel id="glMasks" />
  ) : (
    <div>
      <CheckbookConfigurationNavBar />
      <Layout>
        <CheckbookConfigurationTable />
      </Layout>
    </div>
  );
};

export default CheckbookConfiguration;
